import { useFrame } from "@react-three/fiber";
import React, { useRef } from "react";
import Planet from "./Planet";
import OmPlanet from "./OmPlanet";
import CenterPlanet from "./CenterPlanet";
const Planets = (props) => {
  const { planetData } = props;
  const planets = useRef();

  useFrame(({ clock }) => {
    planets.current.rotation.y = clock.getElapsedTime() * 0.1;
  });
  return (
    <group ref={planets}>
      {planetData &&
        planetData.map((project, index) => {
          if (project.projectSlug.current === "no-6-the-dreams-and-feelings-issue") {
            return (
              <CenterPlanet
                planetImage={project.planetImage}
                position={project.planetPosition}
                slug={`/projects/${project.projectSlug.current}`}
                key={index}
              />
            );
          } else {
            return (
              <Planet
                planetImage={project.planetImage}
                position={project.planetPosition}
                slug={`/projects/${project.projectSlug.current}`}
                key={index}
                om={false}
              />
            );
          }
        })}

      <OmPlanet
        planetImage={"/OmFries.png"}
        position={"-3.8,0,1.2"}
        slug={"/OmFries"}
        om={false}
      />
    </group>
  );
};

export default Planets;
